import logo from '../../assets/logo.png';
import { useState } from 'react';
import { handleEmailClick } from '../../utils/handleEmailClick';
import { onClickUrl } from '../../utils/openinNewTab';
import { resetPassword } from '../../api/identity';

const RequestResetPassword = () => {
  const [email, setEmail] = useState('');
  const [requested, setRequested] = useState(false);

  const handleChange = (e: any) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await resetPassword(email);
    } catch (error: any) {
      console.error(error);
    }
    setRequested(true);
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen relative">
      <div className="flex flex-col items-center bg-grey rounded-3xl p-8 w-[370px] md:w-[500px] md:m-4">
        <img src={logo} className="h-8 mb-8" />
        <h1 className="text-xl">Reset Password</h1>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-col items-center">
            {!requested ? (
              <>
                <input
                  className="bg-lightgrey rounded-3xl px-4 py-2 mt-4 w-72"
                  type="text"
                  placeholder="Insert email address"
                  onChange={handleChange}
                  value={email}
                />
                <button
                  className={`rounded-3xl text-black px-4 py-2 mb-4 mt-6 w-72 hover:brightness-90
                ${email.length >= 1 ? 'bg-yellow' : 'bg-white '}`}
                  type="submit"
                  disabled={email.length < 1}
                >
                  {`Request password reset >`}
                </button>
              </>
            ) : (
              <p className="text-white px-4 py-2 mb-4 mt-8">
                Password reset requested
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestResetPassword;
